import {inject, Injectable} from "@angular/core";
import {FarmApiClient} from "src/app/infrastructure/moovement-api/web-api/farm.api-client";
import {DataStorageService} from "src/app/infrastructure/data-storage.service";
import {DeviceAssociation, SynchronizationStatus, WaterPoint} from "src/app/infrastructure/moovement-api/models/asset";
import {WaterPointsStore} from "src/app/domain/assets/water-points/water-points.store";
import {WaterPointApiClient} from "src/app/infrastructure/moovement-api/web-api/water-point.api-client";
import {tap} from "rxjs";
import {DataType} from "src/app/domain/domain-models";

@Injectable({
  providedIn: 'root'
})
export class WaterPointsService {

  private waterPointsStore = inject(WaterPointsStore);

  constructor(
    private farmApiClient: FarmApiClient,
    private dataStorageService: DataStorageService,
    private waterPointApiClient: WaterPointApiClient
  ) {}

  reset() {
    this.waterPointsStore.reset();
  }

  loadWaterPoints(farmId: string, deviceAssociations: DeviceAssociation[]): void {
    this.farmApiClient.getWaterPoints(farmId).subscribe({
      next: async waterPoints => {
        const filteredWaterPoints = waterPoints.filter(waterPoint => deviceAssociations.some(association => association.assetId == waterPoint.id));
        for (const waterPoint of filteredWaterPoints) {
          await this.persist(waterPoint);
        }
        this.waterPointsStore.setAllEntities(filteredWaterPoints);
      },
      error: async () => {
        const cachedWaterPoints = await this.dataStorageService.getAllActiveAssetsMatching<WaterPoint>(DataType.waterPoints, farmId);
        this.waterPointsStore.setAllEntities(cachedWaterPoints);
      }
    });
  }

  private async persist(waterPoint: WaterPoint) {
    await this.dataStorageService.saveAsset(DataType.waterPoints, waterPoint.farmId, waterPoint, SynchronizationStatus.upToDate);
  }

  create(waterPoint: WaterPoint) {
    return this.waterPointApiClient.create(waterPoint).pipe(
      tap(waterPoint => this.waterPointsStore.setEntity(waterPoint)),
      tap(waterPoint => this.persist(waterPoint))
    );
  }

  mergeWaterPoint(waterPoint: WaterPoint) {
    return this.waterPointApiClient.mergeWaterPoint(waterPoint).pipe(
      tap(waterPoint => this.waterPointsStore.setEntity(waterPoint)),
      tap(waterPoint => this.persist(waterPoint))
    );
  }
}
